import styles from './IdentityVerification.module.css';
import { motion } from 'framer-motion';
import { UserCog } from 'lucide-react';
import { useModal } from '../../hooks/modalContext';

const IDVChangeRequest = () => {
  const { setModal, modalState } = useModal();
  const messageFromAdmin = modalState?.messageFromAdmin as string | undefined;
  const isNewIdvRequired = Boolean(modalState?.isNewIdvRequired);

  return (
    <motion.main
      className={`${styles.main} ${styles.centeredMain}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <UserCog stroke='#f1b100' size={60} className={styles.successImg} />

      <p className={`${styles.successText} text-[--text-main]`}>Changes requested</p>

      <p className={styles.successPara}>
        {messageFromAdmin
          ? messageFromAdmin
          : 'Admin has requested some changes to your profile. Please review and update your information to proceed.'}
      </p>

      <div className={styles.buttonsWrap}>
        <button
          className={`submitBtn ${styles.successBtn} w-full text-center hover:text-[#fff]`}
          onClick={() =>
            setModal('complete-building', {
              tenantBuildingId: modalState?.tenantBuildingId || '',
              isChangeRequest: true,
              isNewIdvRequired,
            })
          }
        >
          Edit profile
        </button>
      </div>
    </motion.main>
  );
};

export default IDVChangeRequest;
